import { InputError } from "@app/components/core/InputError/InputError"
import { classNamez } from "@tecreation/funnel-components"
import "./Selectbox.css"

export const SelectBox = ({ children, value, autocomplete, formRegister, classname, onChange, errors, label }) => {
	const errorMessage = formRegister && errors && errors[formRegister.name] ? errors[formRegister.name].message : undefined
	const selectId = formRegister?.name ? `select-${formRegister.name}` : undefined
	return (
		<div className="relative">
			<select
				{...formRegister}
				id={selectId}
				autoComplete={autocomplete}
				defaultValue={value}
				className={"selectbox primary color-border-primary " + classname + classNamez({ "has-error": !!errorMessage })}
				style={{ borderColor: "white", backgroundColor: "transparent" }}
				onChange={onChange}
				required
			>
				{children}
			</select>
			{label ? <label htmlFor={selectId}>{label}</label> : ""}
			{formRegister && <InputError message={errorMessage} />}
		</div>
	)
}
